var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBarsHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12h6v-2H0zM0 0v2h18V0zm0 7h12V5H0z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,ICAgIDxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTggMTIiPgogICAgPHBhdGgKICAgICAgICAgICAgZD0iTTMsMThIOVYxNkgzWk0zLDZWOEgyMVY2Wm0wLDdIMTVWMTFIM1oiCiAgICAgICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zIC02KSIKICAgICAgICAgICAgZmlsbD0iY3VycmVudENvbG9yIgogICAgLz4KPC9zdmc+";
export { SvgBarsHorizontal as ReactComponent };